import { IPageExtendBehavior, IPageExtendBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanExtraPageAddible } from "../../../beans/objects";
import { IntegerTranslator } from "../../values";

export class PageExtendBehaviorTranslator {
  from(bean: IObjectBeanExtraPageAddible): IPageExtendBehavior {
    return {
      isEnable: !!bean["@auto-notepage-size"],
      fontSizeThreshold: bean["@auto-notepage-size"] ? this.integer.from(bean["@auto-notepage-size"]) : 5,
      shouldMoveAllText: (bean["@auto-notepage-type"] !== "1"),
      shouldOverwrite: (bean["@auto-notepage-overwrite"] === "1"),
    };
  }

  to(o: IPageExtendBehaviorSpecifiable) {
    return {
      autoNotepageSize: o.pageExtendBehavior.isEnable
        ? this.integer.to(o.pageExtendBehavior.fontSizeThreshold) + ".0"  // v1の出力形式に合わせる.
        : undefined,
      autoNotepageType: (!o.pageExtendBehavior.shouldMoveAllText)
        ? "1"
        : undefined,
      autoNotepageOverwrite: (o.pageExtendBehavior.shouldOverwrite)
        ? "1"
        : undefined,
    };
  }

  private readonly integer = new IntegerTranslator();
}
